export { default as RateServiceStore } from './RateServiceStore';



// WEBPACK FOOTER //
// ./src/modules/rate/stores/index.js